import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Checkbox,
  Grid,
  Dropdown,
  Icon,
  Item,
  Message,
  Popup
} from 'semantic-ui-react';
import globalStyles from '../../globals.scss';
import { withRouter, Link } from 'found';
import withAuth from '../../App/Authenticate';
import MobileHeader from '../../App/MobileHeader';
import styles from './EventList.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../../lib/stylesheets/ExpandCollapseTransition.css';

const EventIndexComponent = class EventIndex extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    location: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
    sidebarOpen: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      showFilters: false
    };
    this.handleHidden = this.handleHidden.bind(this);
    this.statusChange = this.statusChange.bind(this);
    this.statusChangeMobile = this.statusChangeMobile.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
    this.handleSortByDropdownChange = this.handleSortByDropdownChange.bind(
      this
    );
    this.changeView = this.changeView.bind(this);
  }

  setQuery(key, value) {
    const { pathname, query } = this.props.location;
    query[key] = value;
    this.props.router.replace({ pathname, query });
  }

  handleHidden(e, props) {
    this.setQuery('hidden', props.checked ? 'true' : 'false');
  }

  sortBy(filter) {
    this.setQuery('sortBy', filter);
  }

  handleSortByDropdownChange(e, selection) {
    this.setQuery('sortBy', selection.value);
  }

  statusChangeMobile(e) {
    this.setQuery('status', e.target.value);
  }

  statusChange(e, input) {
    this.setQuery('status', input.value);
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters });
  }

  changeView(pathname) {
    const { query } = this.props.location;
    if (pathname === '/calendar') query.sortBy = 'RECENT';
    this.props.router.push({ pathname, query });
  }

  render() {
    const { query, pathname } = this.props.location;
    const { children, router, sidebarOpen, toggleSidebar, viewer } = this.props;
    const hiddenHelp = (
      <Icon name='help circle' className={globalStyles.borderGrey} />
    );

    const bookingStatusMappings = {
      ALL: 'All',
      BOOKED: 'Booked',
      INITIAL: 'Not Booked',
      CANCELED: 'Canceled'
    };

    const bookingStatusOptions = [
      { text: bookingStatusMappings.ALL, value: 'ALL' },
      { text: bookingStatusMappings.BOOKED, value: 'BOOKED' },
      { text: bookingStatusMappings.INITIAL, value: 'INITIAL' },
      { text: bookingStatusMappings.CANCELED, value: 'CANCELED' }
    ];

    const sortByButtons = (
      <Button.Group basic size='small'>
        <Button
          onClick={this.sortBy.bind(this, 'RECENT')}
          active={query.sortBy === 'RECENT'}
        >
          All
        </Button>
        <Button
          onClick={this.sortBy.bind(this, 'UPCOMING')}
          active={query.sortBy === 'UPCOMING' || !query.sortBy}
        >
          Upcoming
        </Button>
        <Button
          onClick={this.sortBy.bind(this, 'PAST')}
          active={query.sortBy === 'PAST'}
        >
          Past
        </Button>
      </Button.Group>
    );

    const sortByOptions = [
      { text: 'All Events', value: 'RECENT' },
      { text: 'Upcoming Events', value: 'UPCOMING' },
      { text: 'Past Events', value: 'PAST' }
    ];

    const viewPicker = (
      <Button.Group basic size='small'>
        <Button
          icon='list'
          active={pathname === '/'}
          onClick={this.changeView.bind(null, '/')}
        />
        <Button
          icon='calendar alternate outline'
          active={pathname === '/calendar'}
          onClick={this.changeView.bind(null, '/calendar')}
        />
      </Button.Group>
    );

    return (
      <div className={styles.scrollContainer}>
        <MobileHeader
          viewer={viewer}
          router={router}
        >
          <div className='menu'>
            <Item
              as='a'
              className={sidebarOpen ? 'active ' : ''}
              onClick={toggleSidebar}
            >
              <Icon name='sidebar' />
            </Item>
          </div>
          <div className='right menu'>
            <Item as='a' onClick={router.push.bind(null, '/search')}>
              <Icon name='search' />
            </Item>
            <Item as={Link} to='/events/new'>
              <Icon name='add' />
            </Item>
          </div>
        </MobileHeader>
        <Grid container verticalAlign='middle'>
          {this.props.viewer.needs_square_scopes &&
            <Grid.Row>
              <Grid.Column>
                <Message negative>
                  <Message.Header>Please login to your Square account</Message.Header>
                  <p>We have made some updates to our Square integration. In order to continue accepting credit card payments, you must log into your Square account by <strong>March 19th, 2021,</strong> and reauthorize Cloverbook.</p>
                  <Button color='blue' content='Connect with Square' onClick={() => { window.location = '/auth/square'; }} />
                </Message>
              </Grid.Column>
            </Grid.Row>
          }
          <Grid.Row only='computer' style={{ padding: '2em 0' }}>
            <Grid.Column width={5}>
              <span>
                {viewPicker}
                <span style={{ paddingLeft: '2em' }}>
                  <Checkbox
                    onChange={this.handleHidden}
                    checked={query.hidden === 'true'}
                    label='Include Archived'
                  />
                  &nbsp;
                  <Popup
                    trigger={hiddenHelp}
                    on='hover'
                    position='right center'
                    inverted
                    content='This includes events you may have hidden by archiving'
                  />
                </span>
              </span>
            </Grid.Column>
            <Grid.Column width={6} textAlign='center'>
              {pathname === '/' && sortByButtons}
            </Grid.Column>
            <Grid.Column width={5} textAlign='right'>
              <span style={{ paddingRight: '1em' }}>Booking Status:</span>
              <Dropdown
                style={{ minWidth: '8em' }}
                selection
                options={bookingStatusOptions}
                name='status'
                value={query.status || 'ALL'}
                text={bookingStatusMappings[query.status]}
                onChange={this.statusChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row only='tablet mobile' style={{ paddingBottom: '2em' }}>
            <Grid.Column>
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <div style={{ display: 'table' }}>
                      <div
                        style={{ display: 'table-cell', paddingRight: '1em' }}
                      >
                        {viewPicker}
                      </div>
                      <div style={{ display: 'table-cell', width: '100%' }}>
                      {pathname === '/' &&
                        <Dropdown
                          selection
                          button
                          basic
                          fluid
                          onChange={this.handleSortByDropdownChange}
                          options={sortByOptions}
                          value={query.sortBy || 'UPCOMING'}
                        />
                      }
                      </div>
                      <div
                        style={{ display: 'table-cell', paddingLeft: '1em' }}
                      >
                        {/* Despite having a single button, we use a button
                          group to match the style of the viewPicker buttons. */}
                        <Button.Group basic>
                          <Button
                            active={this.state.showFilters}
                            onClick={this.toggleFilters}
                            style={{
                              padding: '0.78571429em'
                            }}
                          >
                            <Icon
                              name='filter'
                              className={[
                                styles.filter,
                                (query.status && query.status !== 'ALL') ||
                                query.hidden === 'true'
                                  ? styles.filterActive
                                  : ''
                              ].join(' ')}
                            />
                          </Button>
                        </Button.Group>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <ReactCSSTransitionGroup
                transitionName='background'
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}
              >
                {this.state.showFilters &&
                  <div key='mobileFilters'>
                    <div className={styles.mobileFilters}>
                      <Grid columns='equal' verticalAlign='middle'>
                        <Grid.Row>
                          <Grid.Column textAlign='left'>
                            <p>Booking Status</p>
                            <select
                              value={query.status || 'ALL'}
                              style={{ minWidth: '8em' }}
                              name='status'
                              className='ui selection dropdown'
                              onChange={this.statusChangeMobile}
                            >
                              <option value='ALL'>All</option>
                              <option value='BOOKED'>Booked</option>
                              <option value='INITIAL'>Not Booked</option>
                            </select>
                          </Grid.Column>
                          <Grid.Column textAlign='right'>
                            <p>Include Archived</p>
                            <Checkbox
                              toggle
                              onChange={this.handleHidden}
                              checked={query.hidden === 'true'}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </div>
                  </div>}
              </ReactCSSTransitionGroup>
            </Grid.Column>
          </Grid.Row>
          {React.cloneElement(children, {
            toggleFilters: this.toggleFilters,
            showFilters: this.state.showFilters,
            toggleSidebar,
            sidebarOpen
          })}
        </Grid>
      </div>
    );
  }
};

export default withRouter(withAuth(EventIndexComponent));



// WEBPACK FOOTER //
// ./webpack/components/Event/List/index.js